import {create} from 'zustand';
export const useDashboardStore = create((set) => ({
    dashboard: null,
    setDashboard: (dashboard) => set({ dashboard }),
}));